import React from 'react';
import { faInfoCircle, faTimes, faTimesCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { IconWrapper } from '../common/IconWrapper';

export default function AlertTemplate({ message, options, close }) {
    return (
        <div
            id="alerttemp"
            className={'alert-template flex ' + (options.type === 'error' ? 'error-alert' : '')}
            role={'alert'}
        >
            <div className={'alert-icon'}>
                {options.type === 'info' && <IconWrapper icon={faInfoCircle} />}
                {options.type === 'success' && <IconWrapper icon={faCheckCircle} />}
                {options.type === 'error' && <IconWrapper icon={faTimesCircle} />}
            </div>
            <span style={{ flex: 2 }}>{message}</span>
            <button onClick={close} className="alert-button">
                <IconWrapper icon={faTimes} />
            </button>
        </div>
    );
}
